<template>
  <section class="page-container">
    <div class="flex flex-align-center flex-sb-center">
      <div class="total">
        <div
          v-for="(item,i) in summary"
          :key="'summary_'+i"
          class="item">
          <span class="num">{{item.value}}</span>
          <span>{{item.name}}</span>
        </div>
      </div>
    </div>
    <div class="filter-top">
      <!--      <span>Search</span>-->
      <v-input
        v-model="search"
        placeholder="Customer Name, Registration No."
        @keyEnter="filterData" />
    </div>
    <div class="filter-card">
      <div class="filter-main">
        <div class="filter-left">
          <div class="form-item">
            <span>Creation Date</span>
            <v-date-picker
              v-model="date"
              type="daterange"
              @change="changeDate" />
          </div>
        </div>
        <div class="filter-middler">
          <div class="form-item">
            <span>
              Status
              <span
                class="all"
                @click="handlerSelectAll('status')">All</span>
              <span
                class="all"
                @click="handlerNoneAll('status')">None</span>
            </span>
            <div class="flex-sb">
              <div class="form-half">
                <v-checkbox-group
                  v-model="status"
                  :list="statusList"
                  @change="filterData">
                  <template #default="{ item }">
                    <span class="flex-sb-center">
                      <span
                        class="circle"
                        :class="{
                          'blue': item.id == 3,
                          'dark': item.id == 4,
                          'orange': item.id == 1,
                          'green': [2].includes(item.id),
                        }"></span>
                      <span>{{ item['name'] }}</span>
                    </span>
                  </template>
                </v-checkbox-group>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="video-container">
      <section
        ref="sortable"
        class="content-container">
        <template v-if="weeklyList.length>0">
          <div
            v-for="(item,index) in weeklyList"
            :ref="'weekly_'+index"
            :key="item.id"
            :data-id="item.id"
            class="item weekly_item">
            <div class="video-wrapper ">
              <iframe
                width="237"
                class="video-border"
                height="142"
                :src="item.link"
                title="YouTube
              video
              player"
                frameborder="0"
                allow="accelerometer"
                autoplay
                clipboard-write
                encrypted-media
                gyroscope
                picture-in-picture
                web-share
                allowfullscreen></iframe>
            <!--            <video-->
            <!--              :ref="'video-play-'+index"-->
            <!--              class="video-box img"-->
            <!--              :controls="false"-->
            <!--              src="https://holdcover.s3.ap-east-1.amazonaws.com/videos/Referral_Program_Holdcover_zh_hk.mp4"-->
            <!--              @click="handleVideoPlay(index)"></video>-->
            <!--            <div class="video-pouse-container">-->
            <!--              <span>-->
            <!--                <span><img src="@/assets/logo.png"></span>-->
            <!--                <span>車CAM直擊-WT478新年過左...</span>-->
            <!--              </span>-->
            <!--              <span class="video-play">-->
            <!--                <font-awesome-icon icon="play"></font-awesome-icon>-->
            <!--              </span>-->
            <!--            </div>-->
            </div>
            <div class="footer">
              <span>
                <v-button
                  class="del-btn__label"
                  gray
                  icon="xmark"
                  @click="handleWeekly(item)"></v-button>
              </span>
              <div class="info">
                <p class="item_title">
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="item.title"
                    placement="top">
                    <span>{{item.title}}</span>
                  </el-tooltip>
                </p>
                <p class="time flex-sb-center">
                  <span>{{item.created_date}}</span>
                  <span>{{item.registration_no}}</span>
                </p>
              </div>
              <span
                class="icon"
                @mousedown="handleClick(item)"
                @mouseenter="handleMouseEnter"
                @mouseleave="handleMouseLeave">
                <font-awesome-icon icon="grip-lines" />
              </span>
            </div>
          </div>
        </template>
      </section>
    </div>
    <div class="transparent">
      <el-table
        :data="tableData"
        style="width: 100%"
        :row-class-name="'table-pointer'"
        :header-row-class-name="'tableHeader'"
        @row-click="handleRow"
      >
        <el-table-column
          width="60px"
          align="center">
          <template>
            <div
              class="flex-algin"
            >
              <p class="icon icon-text">
                <font-awesome-icon
                  icon="bomb"
                  class="icon-color"/>
              </p>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          width="105px"
          label="Created Date">
          <template #default="{row}">
            <div class="flex-algin fs-12 time-text">
              <span>{{ row.created_date}}</span><br>
              <span> {{ row.created_time }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="Uploaded File">
          <template #default="{row}">
            <span class="break-word">{{`${row.file_name} - ${row.ext}`||'-'}}</span>
            <p
              class="liter-text">
              <!--              <span>{{row.created_time}}</span>-->
              <span>{{row.file_size}}</span>
            </p>
          </template>
        </el-table-column>
        <el-table-column
          label="Registration No.">
          <template #default="{row}">
            <span class="break-word">{{row.registration_no||'-'}}</span>
          </template>
        </el-table-column>

        <el-table-column
          label="Account Name">
          <template #default="{ row }">
            <span class="break-word">{{row.username||'-'}}</span>
            <p class="liter-text">{{row.mobile_no}}</p>
          </template>
        </el-table-column>
        <el-table-column
          width="120px"
          :show-overflow-tooltip="true"
          label="Status">
          <template #default="{ row }">
            <div class="flex-algin status-height">
              <p class="flex flex-align-center">
                <span
                  class="span-status"
                  :class="{
                    'blue': row.status ==3,
                    'dark': row.status == 4,
                    'orange': row.status == 1,
                    'green': [2].includes(row.status),
                  }">
                  {{ getOptionName('carbombStatutList',row.status) }}
                </span>
                <span
                  v-if="row.weekly==1"
                  class="icon-width"
                >
                  <img src="@/assets/images/icon/star-solid.svg">
                </span>
              </p>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <v-pagination
      :total="pageConfig.total"
      :current="pageConfig.currentPage"
      @currentChange="currentChange" />
  </section>
</template>

<script>
import {getCarbombList, weeklySortCarbomb, weeklyListCarbomb, summaryCarbomb, editCarbomb} from '@/api/car-bomb'
import {mapActions, mapState} from 'vuex'
import {downloadFile} from '@/utils/download'
import MixinOptions from '@/mixins/options'
import MinxinFormat from '@/mixins/format'
import Sortable from 'sortablejs'

export default {
  name: 'CarBombList',
  components:{
  },
  mixins: [MixinOptions,MinxinFormat],
  data () {
    return {
      search: null,
      date: [],
      status: [],
      tableData:[],
      weeklyList:[],
      pageConfig:{
        total: 0,
        currentPage: 1
      },
      summary:[],
    }
  },
  computed:{
    ...mapState('filter', ['selectFilterData']),
    statusList(){
      return this.carbombStatutList
    },
  },
  watch:{
    property: {
      immediate: true,
      handler() {
        let {policy={}} =  this.selectFilterData||{}
        Object.keys(policy).forEach(item=>{
          this[item] = policy[item]
        })
        this.setFilterData(policy||{})
        this.network().getList()
      }
    },
    date:{
      immediate: true,
      handler(){
        this.$emit('changeDate',this.date)
      }
    },
    carbombListNum:{
      immediate: true,
      handler(val){
        if(val)
          this.$emit('update:carbombNum',val)
      }
    }
  },
  async mounted(){
    await this.network().summaryCarbomb()
    await this.network().weeklyListCarbomb()
    let el = this.$refs['sortable']
    this.createSort(el)
  },
  methods: {
    ...mapActions('filter', ['setFilterData']),
    async handleWeekly({id}){
      await this.network().editCarbomb({id})
      await this.network().weeklyListCarbomb()
      this.filterData()
    },
    handleVideoPlay(index){
      let video  = this.$refs['video-play-'+index][0]
      if (video.paused)
        video.play()
      else
        video.pause()
    },
    createSort(el){
      this.sortable = new Sortable(el,{
        disabled: true,
        onEnd: this.sortEnd
      })
    },
    handleClick(val) {
      this.promotion_id = val.id
    },
    sortEnd(e) {
      // 拖拽完成执行
      const sortableList =  this.$refs['sortable']
      const items = Array.from(sortableList.getElementsByClassName('weekly_item'))
      const sortedIds = items.map(item => item.getAttribute('data-id'))
      // if(e.oldIndex != e.newIndex){
      //   let params = {
      //     promotion_id: this.promotion_id,
      //     old_index: e.oldIndex,
      //     new_index: e.newIndex
      //   }
      //   console.log('e---',e)
      //   return
      this.network().weeklySortCarbomb({id:sortedIds})
      // }
    },
    handleMouseEnter() {
      // 鼠标离开图标控制拖拽关闭
      this.sortable.option('disabled', false)
    },
    handleMouseLeave() {
      // 鼠标进入图标控制拖拽开启
      this.sortable.option('disabled', true)
    },
    handleRow(row){
      const { id, class_id, product_id} = row
      this.$router.push(`/records/micropolicy/car-bomb/${id}`)
    },
    changeDate(){
      this.$emit('changeDate',this.date)
      this.filterData()
    },

    currentChange(page){
      this.pageConfig.currentPage = page
      this.network().getList()
    },
    handleRefresh(){
      this.filterData()
    },
    filterData(){
      this.pageConfig.currentPage = 1
      this.network().getList()
    },

    handlerSelectAll(target){
      let origin = ''
      switch(target) {
        case 'status':
          origin = 'statusList'
          break
        default:
          break
      }
      const data = this[origin].reduce((result, item) => {
        result.push(item.id)
        return result
      }, [])
      this[target] = data
      this.filterData()
    },

    handlerNoneAll(target){
      this[target] = []
      this.filterData()
    },
    handlerDown() {
      this.network().getList({
        is_export: 1
      })
    },

    network(){
      return {
        editCarbomb: async (params) => {
          const { data } = await editCarbomb({
            weekly:0,
            ...params
          })
        },
        summaryCarbomb:async (params) =>{
          const {data} = await summaryCarbomb(params)
          this.summary = data||[]
        },
        weeklyListCarbomb:async (params) =>{
          const {data} = await weeklyListCarbomb(params)
          this.weeklyList = data.data||[]

        },
        weeklySortCarbomb:async (params) =>{
          const {data} = await weeklySortCarbomb(params)

        },
        getList: async (otherParams) => {
          let params = {
            created_start: this.date[0],
            created_end: this.date[1],
            page: this.pageConfig.currentPage,
            search: this.search,
            status: this.status,
            ...otherParams
          }
          if(otherParams && otherParams.is_export == 1){
            const res = await getCarbombList(params,{
              responseType: 'blob',
              timeout: 120000
            })
            downloadFile(res)
          }else
          {
            const { data } = await getCarbombList(params)
            let {meta} = data||{}
            this.pageConfig.currentPage = meta.current_page
            this.pageConfig.total = meta.total
            this.tableData = data.data
          }
        }
      }
    }
  },
}
</script>
<style lang='scss' scoped>
.page-container{
  .break-word{
    word-break: break-word;
  }
  .total{
    //margin-bottom: 20px;
    .item{
      display: inline-block;
      margin-right: 20px;
      .num{
        font-size: 24px;
        font-weight: 400;
        line-height: 36px;
        padding: 0 10px;
      }
    }
  }
  .filter-top{
    margin-top:30px;
    margin-bottom: 30px;
  }
  .filter-card {
    margin-bottom: 30px;
    background: white;
    border: 1px solid #E1E4E8;
    border-radius: 5px;
    .circle {
      display: inline-block;
      margin-right: 5px;
      width: 14px;
      height: 14px;
      min-width: 14px;
      min-height: 14px;
      border-radius: 100%;
      &.orange{
        background: #E36209;
      }
      &.blue {
        background: #0366D6;
      }
      &.yellow-dark {
        background: #DBAB09;
      }
      &.green {
        background: #28A745;
      }
      &.red {
        background: #D73A49;
      }
      &.dark{
        background: #444D56;
      }
    }
    .filter-top {
      display: flex;
      align-items: center;
      padding: 15px;
      border-bottom: 1px solid #E1E4E8;
      & > span {
        display: inline-block;
        padding-right: 10px;
      }
    }
    .filter-main {
      display: flex;
      padding: 0 15px;
      .all {
        display: inline-block;
        padding-left: 15px;
        color: #409eff;
        cursor: pointer;
      }
      .filter-left, .filter-middler, .filter-right {
        padding: 15px 0;
      }
      .filter-left {
        padding-right: 10px;
        width: 290px;
        min-width: 290px;

      }
      .filter-middler {
        padding: 15px 10px;
        border-left: 1px solid #E1E4E8;
        width: 290px;
      }
      .filter-right {
        padding-left: 10px;
        border-left: 1px solid #E1E4E8;
        flex: 1;
      }
    }
  }
  .transparent{
    .product-name{
      word-break: break-word;
      font-size: 14px;
      font-weight: 600;
    }
    .ref{
      font-size: 12px;
      &>span{
        font-weight: 600;
        padding-right: 5px;
      }
    }
    .no-line{
      text-decoration: none;
      color: #606266;
    }
  }
  .span-status {
    display: inline-block;
    padding: 1px 8px;
    font-weight: 600;
    font-size: 12px;
    line-height: 18px;
    color: #FFFFFF;
    border-radius: 100px;
    max-width: 140px;
    word-break:keep-all;
    white-space:nowrap;
    overflow:hidden;
    text-overflow:ellipsis;
    .svg-inline--fa {
      margin-right: 5px;
      font-size: 14px;
    }
    &.green {
      background: #28a745;
      color: white;
    }
    &.blue {
      background: #0366D6;
      color: white;
    }
    &.yellow-dark {
      background: #DBAB09;
    }
    &.orange{
      background: #E36209;
    }
    &.dark{
      background: #444D56;
    }
  }
}
::v-deep .el-table{
  border-radius: 4px;
  border: 1px solid #E1E4E8;
  tr{
    td{
      //display: flex;
      padding: 10px 15px 10px 0!important;
      vertical-align: top;
      margin-right: 15px;
      //height: 40px;
      .cell{
        //min-height: 40px;
        line-height: 20px;
        position: relative;
        height: inherit;
        //margin-left: 10px;
        //margin-right: 10px;
        padding: 0;
        color: #24292E;
        //padding: 5px 10px;
        //position: absolute;
        //top: 10px;
        .liter-text{
          color: #6A737D;
          font-size: 12px;
          &.color-dark{
            color: $dark;
          }
          &.tag-border{
            border: 1px solid #dddfe7;
            border-radius: 4px;
            text-align: center;
            line-height: 18px;
          }
        }
      }
    }
  }
  .table-pointer{
    cursor: pointer;
  }
}
::v-deep .tableHeader {
  margin-top: 30px;
  background: #F6F8FA !important;
  border-bottom: 1px solid #E1E4E8;
  th {
    background-color: #F6F8FA !important;
    font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    letter-spacing: -0.15px;
    padding: 10px 0!important;
    color: #24292E!important;
    .cell{
      padding-left: 0;
    }
  }
  .button-border{
    display: inline-block;
    padding: 0px 10px;
    height: auto;
    font-size: 12px;
    border-radius: 50px;
    border: 1px solid #E1E4E8;
    color: #24292E;
    background: white;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 18px;

  }
}
.mg-r-8{
  margin-right: 8px;
}
.channel{
  font-size: 12px;
  font-weight: 600;
  color: #586069;
}
.icon-color{
  color: #6A737D;
}
.content-container{
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 10px;
  .item{
    margin:0 20px 20px 0;
    width: 237px;
    .img{
      cursor: pointer;
      height: 142px;
      width: 237px;
      border: 1px solid #E1E4E8;
      box-sizing: border-box;
      border-radius: 6px;
      margin: 10px 0px;
      img{
        width: 100%;
        height: 100%;
      }
    }
    .top-tag{
      background: #E1E4E8;
      color: $dark;
      padding: 3px 5px;
      border-radius: 8px;
      font-size: 12px;
      font-weight: 600;

    }
    .footer{
      display: flex;
      align-items: center;
      justify-content: space-between;
      .info{
        margin: 0 8px;
        width: 165px;
        p{
          //width: 182px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .item_title{
          font-family: Inter;
          font-style: normal;
          font-weight: 600;
          font-size: 12px;
          line-height: 18px;
          color: #24292E;
          overflow-wrap: break-word;
          span + span{
            margin: 0 10px;
          }
        }
        .time{
          font-family: Inter;
          font-style: normal;
          font-weight: normal;
          font-size: 12px;
          line-height: 18px;
          color: #6A737D;
        }
        .private{
          color: rgba(88, 96, 105, 1);
          font-size: 12px;
          line-height: 18px;
          font-weight: 600;
          border: 1px solid rgba(225, 228, 232, 1);
          // width: 58px;
          height: 18px;
          border-radius: 100px;
          padding: 0 8px;
          margin: 0 !important;
        }
      }
      .icon{
        width: 14px;
        font-style: normal;
        font-weight: 900;
        font-size: 14px;
        line-height: 20px;
        color: #D1D5DA;
        flex: 1;
        text-align: center;
        //padding: 8px;
      }
    }
  }
  /deep/.del-btn__label{
    display: flex;
    width: 32px;
    justify-content: center;
    .btn-label{
      margin-left: 0;
    }
  }
  .video-wrapper {
    position: relative;
    .video-border{
      border-radius: 8px;
    }
    .video-box{
      height: 142px;
      width: 237px;
    }
    .custom-text {
      position: absolute;
      top: 10px;
      left: 0;
      //transform: translate(-50%, -50%);
      font-size: 12px;
      color: white;
      /* 添加其他样式属性 */
    }
  }
}
.icon-width{
  width: 16px;
  height: 16px;
  display: inline-block;
  margin-left: 7px;
}
</style>
